import React, { useState } from 'react';
import { Element } from 'react-scroll';
import { Collapse } from 'reactstrap';
import { useDesktop } from '../hooks';

const desktopClassName = (desktop: boolean): string =>
  desktop ? 'container-fluid bg-light-gray pt30 pb30' : 'container-fluid';

const coverClassName = (collapse: boolean): string =>
  collapse
    ? 'col-12 border-bottom pt30 pb30 d-block d-md-none mb20'
    : 'col-12 border-bottom pt30 pb30 d-block d-md-none';

export default function ProductCover() {
  const desktop = useDesktop();
  const [collapse, setCollapse] = useState(desktop);

  const toggle = () => setCollapse(!collapse);

  return (
    <div className={desktopClassName(desktop)}>
      <div className="container">
        <div className="row">
          <div
            className={coverClassName(collapse)}
            onClick={toggle}
            role="presentation"
          >
            <i className="material-icons align-middle">keyboard_arrow_right</i>
            ¿Qué cubre?
          </div>
          <Collapse className="col-12" isOpen={collapse}>
            <div className="w-100 d-none d-sm-block mt100" />
            <Element name="cover" className="col-12">
              <h2 className="px-24 text-center mb40">¿Qué cubre?</h2>
            </Element>
            <ul className="col-12 col-sm-10 d-flex flex-wrap text-primary mx-auto mb0 li-custom li-check">
              <li className="col-12 col-sm-6">
                <p className="text-dark-gray">
                  Suma asegurada por muerte accidental
                </p>
              </li>
              <li className="col-12 col-sm-6">
                <p className="text-dark-gray">
                  Indemnización diaria por Hospitalización por Accidente
                </p>
              </li>
              <li className="col-12 col-sm-6">
                <p className="text-dark-gray">
                  Indemnización diaria por Hospitalización por Enfermedad
                </p>
              </li>
              <li className="col-12 col-sm-6">
                <p className="text-dark-gray">
                  Asistencia Dr Kura
                </p>
              </li>
            </ul>
          </Collapse>
        </div>
      </div>
    </div>
  );
}
